// Efeitos das notificações da CONFERÊNCIA FISCAL (Excel em segundo plano).
// Registrado em `constants/notificationHandlers.ts`.

import { toast } from 'sonner';
import type {
  DestinoDeNotificacao,
  MapaDeHandlers,
  NotificacaoParaDestino,
} from '../../../../constants/notificationHandlers';

const TIPO_PRONTA = 'conferencia_exportacao_pronta';

export const ROTA_CONFERENCIA = '/modulesHome/integration/conferencia-fiscal';

/** Param da URL que pede o download ao abrir a tela (clique no sino). */
export const PARAM_BAIXAR = 'baixar';

/** Para onde o clique na notificação leva: a tela no mês da planilha. */
export const rotaDaExportacao = (dados: {
  task_id?: string;
  ano?: number;
  mes?: number;
  baixar?: boolean;
}): string => {
  const p = new URLSearchParams();
  if (dados.ano) p.set('ano', String(dados.ano));
  if (dados.mes) p.set('mes', String(dados.mes));
  if (dados.baixar && dados.task_id) p.set(PARAM_BAIXAR, dados.task_id);
  const qs = p.toString();
  return qs ? `${ROTA_CONFERENCIA}?${qs}` : ROTA_CONFERENCIA;
};

const PREFIXO = 'conferencia_exportacao_';

/** O que a CONFERÊNCIA lê da mensagem do WebSocket. */
export interface DadosWsConferencia {
  task_id?: string;
  ano?: number;
  mes?: number;
}

/** O que a CONFERÊNCIA grava no `dados_json` PERSISTIDO. */
export interface DadosJsonConferencia {
  task_id?: string;
  ano?: number;
  mes?: number;
}

export const baixarComAviso = async (taskId: string): Promise<void> => {
  // Import dinâmico: ver o cabeçalho de `exportacao.ts`.
  const { baixarExportacaoConferencia, ExportacaoIndisponivelError } = await import('./exportacao');
  try {
    await baixarExportacaoConferencia(taskId);
  } catch (err) {
    toast.error(
      err instanceof ExportacaoIndisponivelError
        ? 'Essa planilha já foi baixada ou expirou. Exporte de novo pela Conferência.'
        : 'Não foi possível baixar a planilha. Tente de novo.',
    );
  }
};

export const HANDLERS_CONFERENCIA: MapaDeHandlers = {
  /**
   * Planilha pronta: troca o toast genérico (mesmo `id` do provider) por um
   * com o botão "Baixar", para quem está em qualquer tela não precisar abrir
   * o sino.
   */
  [TIPO_PRONTA]: ({ message }) => {
    const taskId = message.data.task_id;
    if (!taskId) return;
    toast.success('Planilha da conferência pronta', {
      id: `notif-${message.type}-`,
      description: message.data.mensagem,
      duration: 30000,
      dismissible: true,
      action: { label: 'Baixar', onClick: () => baixarComAviso(taskId) },
    });
  },
};

// `function` nomeada: o plugin react do eslint trata arrow com destructuring
// como componente (ver `pages/societario/notificacoes.ts`).
function destinoConferencia({ tipo, dados_json: dados }: NotificacaoParaDestino): string | null {
  if (!String(tipo ?? '').startsWith(PREFIXO)) return null;
  return rotaDaExportacao({
    task_id: dados?.task_id,
    ano: dados?.ano,
    mes: dados?.mes,
    baixar: tipo === TIPO_PRONTA,
  });
}

export const DESTINO_CONFERENCIA: DestinoDeNotificacao = destinoConferencia;
